module.exports = __webpack_public_path__ + "media/images/app/testimonials/trending-1-f9faf4a90fa5f5f3fb935f9b9dfb4737.webp";